import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelCitiesMainContent } from "@website/accommodation-ui/hotel-cities-main-content";
import { HotelFilter } from "@website/accommodation-ui/hotel-filter";
import { HotelListHeader } from "@website/accommodation-ui/hotel-list-header";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { HotelPagination } from "@website/accommodation-ui/hotel-pagination";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { HotelUpdateSearchModal } from "@website/accommodation-ui/hotel-update-search-modal";
import { ListingContainer } from "@website/accommodation-ui/listing-container";
import { SchemaVillaListPage } from "@website/accommodation-ui/scripts";
import { VillaMeta } from "@website/accommodation-ui/villa-meta";
import { VillaSearch } from "@website/accommodation-ui/villa-search";
import { useIsVisible } from "@website/hooks/is-visible";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { Switch } from "@website/ui/switch";
import { isChannel } from "@website/utils/channel/helpers";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { BannerSlide } from "@website/widget/banner-slide";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { AnimatedButton } from "@website/widget/search-map/animatedButton";
import { SeoComponents } from "@website/widget/seo-components";
import { Telesales } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import omit from "lodash-es/omit";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { useState, useSyncExternalStore } from "react";
import Custom404 from "../../[...gone].page";
import { useCityPage } from "./index.hook";
import { CityPagePropertiesType } from "./index.types";
import { VILLA_LOCATION_ROUTE_QUERY_KEYS } from "./seo-category";
const stripCollapseObserverOptions = {
  rootMargin: "120px 0px 0px 0px",
  threshold: 0
};
const stripExpandObserverOptions = {
  rootMargin: "24px 0px 0px 0px",
  threshold: 0
};
type StableStripTriggerState = {
  collapseTriggerInView: boolean;
  expandTriggerInView: boolean;
  stripTriggerInView: boolean;
};
const subscribeToClientRender = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;
const getNextStripTriggerInView = (current: boolean, collapseTriggerInView: boolean, expandTriggerInView: boolean) => {
  if (current && !collapseTriggerInView) return false;
  if (!current && expandTriggerInView) return true;
  return current;
};
const useStableStripTrigger = (collapseTriggerInView, expandTriggerInView) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== collapseTriggerInView || $[1] !== expandTriggerInView) {
    t0 = {
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView: true
    };
    $[0] = collapseTriggerInView;
    $[1] = expandTriggerInView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [state, setState] = useState(t0);
  if (state.collapseTriggerInView !== collapseTriggerInView || state.expandTriggerInView !== expandTriggerInView) {
    let t1;
    if ($[3] !== collapseTriggerInView || $[4] !== expandTriggerInView || $[5] !== state.stripTriggerInView) {
      t1 = getNextStripTriggerInView(state.stripTriggerInView, collapseTriggerInView, expandTriggerInView);
      $[3] = collapseTriggerInView;
      $[4] = expandTriggerInView;
      $[5] = state.stripTriggerInView;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const stripTriggerInView = t1;
    setState({
      collapseTriggerInView,
      expandTriggerInView,
      stripTriggerInView
    });
    return stripTriggerInView;
  }
  return state.stripTriggerInView;
};
const CityPageContent: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(140);
  const router = useRouter();
  const {
    hasMap,
    isNewPlP,
    onMapClick,
    modalProps,
    headerProps,
    searchProperties,
    bannersProperties,
    telesaleProperties,
    hotelPaginationProps,
    hotelListHeaderProps,
    citiesFilterProperties,
    hotelBreadcrumbsProperties,
    hotelCitiesMainContentProps,
    listingContainerProps
  } = useCityPage(properties);
  const zinStoryTag = `${router?.query?.locationType}/${router?.query?.cityTitle}`;
  const {
    reference: stripCollapseTriggerReference,
    inView: stripCollapseTriggerInView
  } = useIsVisible(stripCollapseObserverOptions, true);
  const {
    reference: stripExpandTriggerReference,
    inView: stripExpandTriggerInView
  } = useIsVisible(stripExpandObserverOptions, true);
  const stripTriggerInView = useStableStripTrigger(stripCollapseTriggerInView, stripExpandTriggerInView);
  const t0 = properties?.seoData?.title;
  const t1 = properties?.seoData?.description;
  const t2 = properties.locationData?.type;
  const t3 = properties.locationData?.title;
  const t4 = properties.seoCategory?.title;
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <VillaMeta title={t0} description={t1} locationType={t2} locationTitle={t3} seoCategoryTitle={t4} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `/${properties.locationData?.type}/${properties.locationData?.url}`;
  const t7 = properties?.seoData?.title;
  const t8 = properties?.seoData?.description;
  const t9 = properties.locationData?.title;
  let t10;
  if ($[6] !== hotelCitiesMainContentProps.hotelList || $[7] !== router.locale || $[8] !== router.query.date_from || $[9] !== router.query.date_to || $[10] !== router.query.room_capacity || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <SchemaVillaListPage villas={hotelCitiesMainContentProps.hotelList} path={t6} locale={router.locale} name={t7} description={t8} locationTitle={t9} dateFrom={router.query.date_from} dateTo={router.query.date_to} roomCapacity={router.query.room_capacity} />;
    $[6] = hotelCitiesMainContentProps.hotelList;
    $[7] = router.locale;
    $[8] = router.query.date_from;
    $[9] = router.query.date_to;
    $[10] = router.query.room_capacity;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== stripCollapseTriggerReference) {
    t11 = <div className="absolute inset-x-0 top-0 h-px" ref={stripCollapseTriggerReference} />;
    $[16] = stripCollapseTriggerReference;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== stripExpandTriggerReference) {
    t12 = <div className="absolute inset-x-0 top-0 h-px" ref={stripExpandTriggerReference} />;
    $[18] = stripExpandTriggerReference;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div aria-hidden={true} className="pointer-events-none relative h-0 w-full">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== modalProps) {
    t14 = <HotelUpdateSearchModal {...modalProps} />;
    $[23] = modalProps;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== headerProps) {
    t15 = <Header {...headerProps} />;
    $[25] = headerProps;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="bg-outline-thin h-px w-full" />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = `sticky top-0 bg-white ${searchProperties.isSearchPanelOpen ? "z-20" : "z-10 md:z-20"}`;
  let t18;
  if ($[28] !== isNewPlP || $[29] !== searchProperties) {
    t18 = <VillaSearch {...searchProperties} disableSticky={true} isNewPlP={isNewPlP} />;
    $[28] = isNewPlP;
    $[29] = searchProperties;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== hasMap || $[32] !== hotelListHeaderProps || $[33] !== isNewPlP || $[34] !== onMapClick || $[35] !== stripTriggerInView) {
    t19 = isNewPlP && <HotelListHeader {...hotelListHeaderProps} isSticky={isNewPlP} isStickyPositioned={false} stripTriggerInView={stripTriggerInView} hasMap={hasMap} onMapClick={onMapClick} />;
    $[31] = hasMap;
    $[32] = hotelListHeaderProps;
    $[33] = isNewPlP;
    $[34] = onMapClick;
    $[35] = stripTriggerInView;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t17 || $[38] !== t18 || $[39] !== t19) {
    t20 = <div className={t17}>{t18}{t19}</div>;
    $[37] = t17;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== hasMap || $[42] !== isNewPlP || $[43] !== onMapClick) {
    t21 = isNewPlP && hasMap && onMapClick && <div className="lg:hidden"><AnimatedButton isNewPlP={true} className="bottom-6" icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} /></div>;
    $[41] = hasMap;
    $[42] = isNewPlP;
    $[43] = onMapClick;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  const t22 = `flex flex-col gap-5 ${isNewPlP ? "px-4" : "px-6"} lg:px-6 lg:py-5 xl:mx-auto xl:max-w-[1200px] xl:px-0`;
  let t23;
  if ($[45] !== hotelBreadcrumbsProperties || $[46] !== isNewPlP) {
    t23 = !isNewPlP && <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} /></div>;
    $[45] = hotelBreadcrumbsProperties;
    $[46] = isNewPlP;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  const t24 = `${isNewPlP ? "lg:flex" : ""} hidden flex-row items-center justify-between`;
  let t25;
  if ($[48] !== hotelListHeaderProps.city || $[49] !== hotelListHeaderProps.hasCityPrefix || $[50] !== hotelListHeaderProps.loading || $[51] !== hotelListHeaderProps.totalItem || $[52] !== isNewPlP) {
    t25 = isNewPlP && <div className="lg:mt-0"><HotelCityTitle isNewPlP={isNewPlP} city={hotelListHeaderProps?.city} hasCityPrefix={hotelListHeaderProps?.hasCityPrefix} loading={hotelListHeaderProps?.loading} totalItem={hotelListHeaderProps?.totalItem} /></div>;
    $[48] = hotelListHeaderProps.city;
    $[49] = hotelListHeaderProps.hasCityPrefix;
    $[50] = hotelListHeaderProps.loading;
    $[51] = hotelListHeaderProps.totalItem;
    $[52] = isNewPlP;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== hotelBreadcrumbsProperties) {
    t26 = <div className="hidden lg:flex"><Breadcrumb {...hotelBreadcrumbsProperties} className="hidden lg:flex" /></div>;
    $[54] = hotelBreadcrumbsProperties;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t25 || $[57] !== t26) {
    t27 = <div className="flex flex-col gap-1">{t25}{t26}</div>;
    $[56] = t25;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== hotelListHeaderProps.sortProperties || $[60] !== isNewPlP) {
    t28 = <HotelSortView {...hotelListHeaderProps.sortProperties} isNewPlP={isNewPlP} />;
    $[59] = hotelListHeaderProps.sortProperties;
    $[60] = isNewPlP;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== hasMap || $[63] !== isNewPlP || $[64] !== onMapClick) {
    t29 = hasMap && onMapClick && <AnimatedButton isNewPlP={isNewPlP} className={isNewPlP ? "bottom-6" : "bottom-[20px]"} icon={<MaterialIcon className="text-headline-6" name="map" variant="outlined" />} onClick={onMapClick} expandedText={"\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} text={"\u0646\u0642\u0634\u0647"} />;
    $[62] = hasMap;
    $[63] = isNewPlP;
    $[64] = onMapClick;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t28 || $[67] !== t29) {
    t30 = <div className="flex flex-row items-center gap-4">{t28}{t29}</div>;
    $[66] = t28;
    $[67] = t29;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== t24 || $[70] !== t27 || $[71] !== t30) {
    t31 = <div className={t24}>{t27}{t30}</div>;
    $[69] = t24;
    $[70] = t27;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  const t32 = `${isNewPlP ? "md:block" : ""} p-0`;
  let t33;
  if ($[73] !== bannersProperties?.bannerSlideList || $[74] !== isNewPlP) {
    t33 = !isNewPlP && bannersProperties?.bannerSlideList?.length > 0 && <div className="hidden w-[312px] pb-4 xl:block"><BannerSlide className="p-0" list={bannersProperties?.bannerSlideList} /></div>;
    $[73] = bannersProperties?.bannerSlideList;
    $[74] = isNewPlP;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== citiesFilterProperties || $[77] !== isNewPlP) {
    t34 = <HotelFilter {...citiesFilterProperties} isNewPlP={isNewPlP} />;
    $[76] = citiesFilterProperties;
    $[77] = isNewPlP;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t32 || $[80] !== t33 || $[81] !== t34) {
    t35 = <div className={t32}>{t33}{t34}</div>;
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  const t36 = `flex min-w-0 shrink grow flex-col ${isNewPlP ? "gap-3" : "gap-5"} lg:gap-4`;
  let t37;
  if ($[83] !== hotelListHeaderProps || $[84] !== isNewPlP) {
    t37 = !isNewPlP && <HotelListHeader {...hotelListHeaderProps} />;
    $[83] = hotelListHeaderProps;
    $[84] = isNewPlP;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  const t38 = `${isNewPlP ? "-mt-0" : "-mt-5"} bg-on-color-high-emphasis border-outline-thin -mx-4 border-b px-4 lg:m-0 lg:hidden`;
  let t39;
  if ($[86] !== t38 || $[87] !== zinStoryTag) {
    t39 = <HotelShortVideos className={t38} displayType="STORY" displayId={ZIN_DISPLAY_KEY_STORY_VILLA_CITY_PAGE} zinKey={ZIN_KEY} zinTags={zinStoryTag} />;
    $[86] = t38;
    $[87] = zinStoryTag;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== hotelListHeaderProps.city || $[90] !== hotelListHeaderProps.hasCityNearby || $[91] !== hotelListHeaderProps.sortProperties || $[92] !== hotelPaginationProps || $[93] !== isNewPlP || $[94] !== router) {
    t40 = isNewPlP && <div className="lg:mt-0 lg:hidden"><div className="flex w-full flex-row items-center justify-between gap-4"><div className="min-w-0 flex-1"><HotelCityTitle className="!pt-0" city={hotelListHeaderProps?.city} hasCityPrefix={router.query.locationType !== "category"} loading={hotelPaginationProps.loading} totalItem={hotelPaginationProps.totalCount} /></div><div className="flex shrink-0 flex-row items-center gap-2">{hotelListHeaderProps?.hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch name="nearby" key={`nearby=${router.query?.nearby}`} label={"\u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
            query: deepOmit({
              ...omit(router.query, ["geo_property_summary"]),
              nearby: !router.query?.nearby || undefined
            }, isFilled)
          }, undefined, {
            shallow: true,
            scroll: false
          })} color="secondary" className="!text-body-2 flex flex-row-reverse !items-center !justify-end !whitespace-nowrap !pb-0 lg:!hidden" />}<HotelSortView {...hotelListHeaderProps.sortProperties} buttonProps={{
            "aria-label": "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
            children: undefined,
            className: "!px-0 [&>span:first-child]:!h-9 [&>span:first-child]:!w-9",
            color: router.query.order_by ? "secondary" : "neutral",
            equalDimension: true,
            size: "small",
            StartIcon: <MaterialIcon className="text-[24px] leading-9" name="sort" />,
            variant: "text"
          }} isNewPlP={isNewPlP} /></div></div></div>;
    $[89] = hotelListHeaderProps.city;
    $[90] = hotelListHeaderProps.hasCityNearby;
    $[91] = hotelListHeaderProps.sortProperties;
    $[92] = hotelPaginationProps;
    $[93] = isNewPlP;
    $[94] = router;
    $[95] = t40;
  } else {
    t40 = $[95];
  }
  let t41;
  if ($[96] !== hotelCitiesMainContentProps || $[97] !== isNewPlP || $[98] !== listingContainerProps) {
    t41 = isNewPlP ? <ListingContainer {...listingContainerProps} /> : <HotelCitiesMainContent {...hotelCitiesMainContentProps} />;
    $[96] = hotelCitiesMainContentProps;
    $[97] = isNewPlP;
    $[98] = listingContainerProps;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== hotelPaginationProps || $[101] !== t41) {
    t42 = <div className="relative"><HotelPagination {...hotelPaginationProps}>{t41}</HotelPagination></div>;
    $[100] = hotelPaginationProps;
    $[101] = t41;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== hasMap || $[104] !== isNewPlP || $[105] !== onMapClick) {
    t43 = hasMap && !isNewPlP && <AnimatedButton className="bottom-[20px] self-center md:bottom-6 md:!self-auto xl:!hidden" icon={<MaterialIcon name="map" variant="outlined" />} isNewPlP={isNewPlP} onClick={onMapClick} text={"\u0646\u0645\u0627\u06CC\u0634 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"} />;
    $[103] = hasMap;
    $[104] = isNewPlP;
    $[105] = onMapClick;
    $[106] = t43;
  } else {
    t43 = $[106];
  }
  let t44;
  if ($[107] !== t36 || $[108] !== t37 || $[109] !== t39 || $[110] !== t40 || $[111] !== t42 || $[112] !== t43) {
    t44 = <main className={t36}>{t37}{t39}{t40}{t42}{t43}</main>;
    $[107] = t36;
    $[108] = t37;
    $[109] = t39;
    $[110] = t40;
    $[111] = t42;
    $[112] = t43;
    $[113] = t44;
  } else {
    t44 = $[113];
  }
  let t45;
  if ($[114] !== t35 || $[115] !== t44) {
    t45 = <div className="relative flex">{t35}{t44}</div>;
    $[114] = t35;
    $[115] = t44;
    $[116] = t45;
  } else {
    t45 = $[116];
  }
  let t46;
  if ($[117] !== properties.seoData) {
    t46 = <div className="w-full px-6 py-2 xl:mx-auto xl:max-w-[1200px]"><SeoComponents seoData={properties.seoData} linksTitle={"\u0627\u062C\u0627\u0631\u0647 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u062F\u0631 \u0634\u0647\u0631\u0647\u0627\u06CC \u067E\u0631\u0637\u0631\u0641\u062F\u0627\u0631"} /></div>;
    $[117] = properties.seoData;
    $[118] = t46;
  } else {
    t46 = $[118];
  }
  let t47;
  if ($[119] !== telesaleProperties) {
    t47 = !isChannel(["b2b", "telesale"]) && <Telesales {...telesaleProperties} />;
    $[119] = telesaleProperties;
    $[120] = t47;
  } else {
    t47 = $[120];
  }
  let t48;
  if ($[121] !== t22 || $[122] !== t23 || $[123] !== t31 || $[124] !== t45 || $[125] !== t46 || $[126] !== t47) {
    t48 = <div className={t22}>{t23}{t31}{t45}{t46}{t47}</div>;
    $[121] = t22;
    $[122] = t23;
    $[123] = t31;
    $[124] = t45;
    $[125] = t46;
    $[126] = t47;
    $[127] = t48;
  } else {
    t48 = $[127];
  }
  let t49;
  if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <Footer />;
    $[128] = t49;
  } else {
    t49 = $[128];
  }
  let t50;
  if ($[129] !== t13 || $[130] !== t14 || $[131] !== t15 || $[132] !== t20 || $[133] !== t21 || $[134] !== t48) {
    t50 = <div className="bg-dim-background">{t13}{t14}{t15}{t16}{t20}{t21}{t48}{t49}</div>;
    $[129] = t13;
    $[130] = t14;
    $[131] = t15;
    $[132] = t20;
    $[133] = t21;
    $[134] = t48;
    $[135] = t50;
  } else {
    t50 = $[135];
  }
  let t51;
  if ($[136] !== t10 || $[137] !== t5 || $[138] !== t50) {
    t51 = <>{t5}{t10}{t50}</>;
    $[136] = t10;
    $[137] = t5;
    $[138] = t50;
    $[139] = t51;
  } else {
    t51 = $[139];
  }
  return t51;
};
const Index: NextPage<CityPagePropertiesType> = properties => {
  const $ = _c(3);
  const router = useRouter();
  const hasMounted = useSyncExternalStore(subscribeToClientRender, getClientSnapshot, getServerSnapshot);
  const hasQueryParameters = !isEmpty(omit(router.query, VILLA_LOCATION_ROUTE_QUERY_KEYS));
  if (!properties.locationData) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (hasQueryParameters && !hasMounted) {
    return null;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <CityPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";